import { IconButton, Popover, Stack, Typography } from '@mui/material';
import { DigitalClock, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { useRef, useState } from 'react';

import ClockBlackIcon from '../../../../../../assets/svg/clockBlack.svg';

interface SelectTimeComponnentProps {
  selected: string;
  setSelected: (value: string) => void;
  disabled: boolean;
  width?: string;
}

function convertISOToTimeString(time: string): string {
  const dateObject = new Date(time);

  const hours = dateObject.getHours();
  const minutes = dateObject.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';

  const formattedHours = (hours % 12 || 12).toString().padStart(2, '0');
  const formattedMinutes = minutes.toString().padStart(2, '0');

  const timeWithAmPm = `${formattedHours}:${formattedMinutes} ${ampm}`;
  return timeWithAmPm;
}

const SelectTimeComponent = ({
  selected,
  setSelected,
  disabled,
  width,
}: SelectTimeComponnentProps) => {
  const [dropdownAnchor, setDropdownAnchor] =
    useState<HTMLButtonElement | null>(null);
  const [dropdownWidth, setDropdownWidth] = useState<number>(0);
  const selectTimeRef = useRef<HTMLDivElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setDropdownAnchor(event.currentTarget);
    setDropdownWidth(selectTimeRef?.current?.offsetWidth ?? 0);
  };

  const handleClose = () => {
    setDropdownAnchor(null);
  };

  const handleChangeTime = (time: string) => {
    setSelected(time);
    handleClose();
  };

  const open = Boolean(dropdownAnchor);
  const id = open ? 'select-time-popover' : undefined;

  return (
    <Stack
      ref={selectTimeRef}
      direction='row'
      alignItems='center'
      sx={{
        borderWidth: '0px',
        bgcolor: '#00000008',
        width: width ? width : '100%',
        borderRadius: '6px',
        padding: '8px 12px',
        ...(!isNaN(new Date(selected).getDate()) && {
          fontSize: '12px',
          color: 'black',
          backgroundColor: 'white',
          border: '1px solid rgba(0, 0, 0, 0.50)',
          '&:hover': {
            backgroundColor: 'white',
          },
        }),
      }}
    >
      <Typography sx={{ width: '100%' }}>
        {convertISOToTimeString(selected)}
      </Typography>
      <IconButton
        disabled={disabled}
        sx={{ padding: '4px 8px' }}
        onClick={handleClick}
      >
        <img src={ClockBlackIcon} alt='time' />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={dropdownAnchor}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Stack
          sx={{
            minWidth: dropdownWidth !== 0 ? dropdownWidth - 20 : '250px',
            paddingY: '10px',
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DigitalClock
              value={selected ? dayjs(selected) : null}
              onChange={(e) => {
                if (e) {
                  handleChangeTime(e?.format());
                }
              }}
            />
          </LocalizationProvider>
        </Stack>
      </Popover>
    </Stack>
  );
};

export default SelectTimeComponent;
